<template>
  <div class="reports-shell">
    <!-- HERO -->
    <section class="reports-hero">
      <div>
        <p class="eyebrow">LotLedger Wine Bar</p>
        <h1>Reports</h1>
        <p class="hero-copy">
          Pull the numbers that matter: profit, inventory value, and sales mix
        </p>
      </div>
    </section>

    <!-- REPORT CARDS -->
    <section class="reports-grid">
      <router-link
        v-for="report in reports"
        :key="report.title"
        :to="report.route"
        class="report-card"
      >
        <div class="report-icon">
          {{ report.icon }}
        </div>

        <div class="report-content">
          <p class="label">{{ report.kicker }}</p>
          <h2>{{ report.title }}</h2>
          <p>{{ report.description }}</p>
        </div>

        <span class="report-action">
          View →
        </span>
      </router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: "ReportsDashboard",

  data() {
    return {
      reports: [
        {
          title: "Profit & Loss",
          kicker: "Financials",
          description: "Revenue, COGS, expenses, gross profit, and net profit.",
          route: "/reports/profit-loss",
          icon: "₿"
        },
        {
          title: "Inventory Value",
          kicker: "Cellar Value",
          description: "Current inventory quantities and carrying cost valuation.",
          route: "/reports/inventory-value",
          icon: "◆"
        },
        {
          title: "Sales Analysis",
          kicker: "Performance",
          description: "Analyze sales trends, item movement, and service activity.",
          route: "/reports/sales-analysis1",
          icon: "↗"
        },
        {
          title: "Revenue by Class",
          kicker: "Sales Mix",
          description: "See revenue by glasses, bottles, reserves, and plates.",
          route: "/reports/revenue-by-class",
          icon: "◔"
        }
        
      ]
    };
  }
};
</script>

<style scoped>
.reports-shell {
  min-height: 100vh;
  padding: 28px;
  color: #f7efe8;
  font-family: "Inter", "Poppins", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  background:
    radial-gradient(circle at top left, rgba(128, 18, 54, 0.38), transparent 34%),
    radial-gradient(circle at bottom right, rgba(194, 74, 47, 0.18), transparent 32%),
    linear-gradient(135deg, #0d090d 0%, #171016 42%, #24141b 100%);
}

.reports-hero,
.report-card {
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.09);
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.085), rgba(255, 255, 255, 0.035));
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.34);
  backdrop-filter: blur(18px);
}

.reports-hero {
  padding: 32px;
}

.eyebrow,
.label {
  margin: 0 0 8px;
  color: #c8a66a;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 12px;
  font-weight: 900;
}

.label {
  color: #9b8f8b;
  letter-spacing: 0.12em;
}

.reports-hero h1 {
  margin: 0;
  font-size: clamp(46px, 8vw, 86px);
  line-height: 0.9;
  letter-spacing: -0.075em;
}

.hero-copy {
  max-width: 680px;
  margin: 16px 0 0;
  color: #cfc2bd;
  font-size: 16px;
  line-height: 1.5;
}

.reports-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(280px, 1fr));
  gap: 18px;
  margin-top: 18px;
}

.report-card {
  position: relative;
  min-height: 190px;
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 18px;
  padding: 24px;
  color: #f7efe8;
  text-decoration: none;
  overflow: hidden;
  transition:
    transform 0.16s ease,
    box-shadow 0.16s ease,
    border-color 0.16s ease;
}

.report-card::before {
  content: "";
  position: absolute;
  inset: auto -40px -70px auto;
  width: 190px;
  height: 190px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(200, 166, 106, 0.18), transparent 68%);
  pointer-events: none;
}

.report-card:hover {
  transform: translateY(-3px);
  border-color: rgba(200, 166, 106, 0.35);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.42);
}

.report-icon {
  width: 72px;
  height: 72px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  color: #f1c979;
  font-size: 34px;
  font-weight: 900;
  background:
    radial-gradient(circle at top left, rgba(200, 166, 106, 0.22), transparent 45%),
    rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(200, 166, 106, 0.18);
}

.report-content h2 {
  margin: 0;
  font-size: clamp(26px, 4vw, 42px);
  line-height: 0.96;
  letter-spacing: -0.06em;
}

.report-content p:not(.label) {
  max-width: 520px;
  margin: 12px 0 0;
  color: #cfc2bd;
  line-height: 1.45;
}

.report-action {
  position: absolute;
  right: 24px;
  bottom: 20px;
  color: #f1c979;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0.04em;
}

@media (max-width: 850px) {
  .reports-shell {
    padding: 16px;
  }

  .reports-grid {
    grid-template-columns: 1fr;
  }

  .report-card {
    grid-template-columns: 1fr;
  }

  .report-icon {
    width: 62px;
    height: 62px;
    font-size: 28px;
  }
}
</style>